import { render, staticRenderFns } from "./KategoriArtikel.vue?vue&type=template&id=9161c746&scoped=true"
import script from "./KategoriArtikel.vue?vue&type=script&lang=js"
export * from "./KategoriArtikel.vue?vue&type=script&lang=js"
import style0 from "./KategoriArtikel.vue?vue&type=style&index=0&id=9161c746&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9161c746",
  null
  
)

export default component.exports